<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <h1>关于星翰</h1>
        <div class="tabs">
          <a class="tab-item active">
            <div class="tag"></div>
            公司简介
          </a>
          <a href="#culture" class="tab-item">
            <div class="tag"></div>
            企业文化
          </a>
          <a href="#cooperation" class="tab-item">
            <div class="tag"></div>
            合作共赢
          </a>
          <a href="#honors" class="tab-item">
            <div class="tag"></div>
            资质荣誉
          </a>
          <a href="#history" class="tab-item">
            <div class="tag"></div>
            发展历程
          </a>
        </div>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">首页 > 关于星翰</div>
    </div>

    <section class="section intro" ref="introSection" id="company">
      <div class="section-container">
        <div class="intro_content">
          <div class="left">
            <h2 class="title">
              <div class="txt">成为世界一流的</div>
              <div class="txt">
                <span>电子粉体和金属化</span>
                解决方案供应商
              </div>
              <div class="tag"></div>
            </h2>
            <div class="img_wrapper"></div>
            <div class="img_wrapper"></div>
          </div>
          <div class="right">
            <div class="desc" v-html="aboutContent">
              <!-- <p>
                苏州星翰新材料科技有限公司（简称"星翰材料"），成立于2019年6月，是一家专注于电子粉体及下游金属化解决方案研发、生产和销售的国家级专精特新"小巨人"企业，也是国内少数具备"粉浆一体化"量产能力，实现全链条自主可控的平台型电子专用材料供应商。公司以"以材料进步创建美好生活"为使命，致力于解决新能源与半导体领域关键材料的"卡脖子"问题，推动高性能电子材料的国产化进程。
              </p>
              <h3>核心优势</h3>
              <p>
                公司构建了业内领先的"粉浆一体化"技术平台，突破电子粉体与金属化方案的传统研发边界，实现了湿法制粉技术与金属化方案开发的深度融合与价值链整合。已规模量产微纳米级银粉、铜粉、镍粉、银包铜粉、银包镍粉等核心粉体，并广泛应用于光伏导电浆料、半导体封装材料及MLCC专用粉体领域，形成从材料源头至终端应用的全体系自主可控能力。
              </p>
              <h3>技术创新与研发实力</h3>

              <p>
                公司拥有一支由20余位博士领衔、超百人规模的高水平研发团队。公司已提交70余项专利申请，承担了工信部高质量发展专项，并与国内外多所知名高校、科研机构建立深度合作。在"博士下车间"与"工匠精神"双轮驱动的创新文化下，公司具备从实验室到产业化的高效转化能力，持续推进技术突破与产品迭代。
              </p>
              <h3>产业布局与成果</h3>
              <p>
                苏州金属化浆料工程技术中心拥有超4000平研发和生产基地以及完整的太阳能电池片测试线。成功实现10%银含量银包铜浆量产，低温固化银包铜浆料占据国内市场份额前列，高温烧结降银产品开发水平位居行业第一梯队，助力光伏客户显著降本增效。其超低银含量及无银光伏金属化浆料技术入选苏州市全球"揭榜挂帅"关键核心技术攻关项目。
              </p>
              <p>
                河南济源金属功能粉体工程技术中心拥有超7000平研发和生产基地，核心成果超细银包铜粉入选工信部首批次新材料保险补偿项目，彰显技术领先与产业化价值。
              </p>
              <p>
                星翰材料，以创新驱动材料进步，以协同赋能产业未来，矢志成为世界一流的电子粉体及金属化解决方案供应商。
              </p> -->
            </div>
            <div class="numbers">
              <div class="number_item">
                <NumberCounter
                  :target="400"
                  suffix="+"
                  :start-animation="introVisible"
                />
                <p>雇员人数</p>
              </div>
              <div class="number_item">
                <NumberCounter
                  :target="4"
                  suffix=""
                  :start-animation="introVisible"
                />
                <p>实验室平台</p>
              </div>
              <div class="number_item">
                <NumberCounter
                  :target="30"
                  suffix="%"
                  :start-animation="introVisible"
                />
                <p>市场占有率</p>
              </div>
              <div class="number_item">
                <NumberCounter
                  :target="10"
                  suffix="+"
                  :start-animation="introVisible"
                />
                <p>主要荣誉</p>
              </div>
            </div>
            <div class="numbers">
              <div class="number_item">
                <NumberCounter
                  :target="70"
                  suffix="+"
                  :start-animation="introVisible"
                />
                <p>专利及认证数量</p>
              </div>
              <div class="number_item">
                <NumberCounter
                  :target="10"
                  suffix="+"
                  :start-animation="introVisible"
                />
                <p>合作高校与科研机构</p>
              </div>
              <div class="number_item">
                <NumberCounter
                  :target="70"
                  suffix="+"
                  :start-animation="introVisible"
                />
                <p>博士与硕士</p>
              </div>
              <div class="number_item">
                <NumberCounter
                  :target="3"
                  suffix=""
                  :start-animation="introVisible"
                />
                <p>参与制定国家标准</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section target" id="culture">
      <div class="section-container">
        <div class="img-wrapper"></div>
        <div class="target_extra">
          <div class="target_item">
            <div class="icon"></div>
            <div class="detail">
              <h3 class="title">公司愿景</h3>
              <p class="desc">成为世界一流的电子粉体和金属化解决方案供应商</p>
            </div>
          </div>
          <div class="target_item">
            <div class="icon"></div>
            <div class="detail">
              <h3 class="title">核心价值观</h3>
              <p class="desc">
                成就客户 诚信担当 艰苦奋斗 贡献为本 开放合作 止于至善
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      class="section coopration"
      data-aos="fade-up"
      data-aos-delay="200"
      id="cooperation"
    >
      <div class="section-container">
        <h2 class="title">合作共赢</h2>
        <p class="title_desc">
          凭借技术研发、产品制造和服务响应方面的优势，我们与众多行业知名企业建立了稳固的合作伙伴关系
        </p>
         <!-- <img class="companys companys_pc" src="../static/about/coporate.png" alt="" />
        <img class="companys companys_mobile" src="../static/about/coporate_mobile.png" alt="" /> -->
        <img class="companys companys_pc" :src="cooperationImagePC" alt="" />
        <img class="companys companys_mobile" :src="cooperationImageMobile" alt="" />
      </div>
    </div>

    <section class="section honor" ref="team" id="honors">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">资质荣誉</div>
          <div class="tag"></div>
        </h2>
        <div class="pc_honor">
          <HorizontalScrollIntervalPro
            :wrapperHeight="365"
            :items="honorImages"
            :itemWidth="294"
            :itemHeight="196"
            :paddingX="0"
            :gap="214"
            :activeScale="1.86"
            :stepInterval="20000000"
          >
            <template v-slot="{ index, item }">
              <img
                :src="item"
                alt=""
                style="height: 100%; object-fit: contain"
              />
            </template>
          </HorizontalScrollIntervalPro>
        </div>
        <div class="mobile_hornor">
          <el-carousel
            ref="stepCarousel"
            :interval="5000"
            arrow="always"
            height="185px"
            indicator-position="none"
            :autoplay="true"
          >
            <el-carousel-item v-for="item in honorImages" :key="item">
              <div class="custom">
                <img :src="item" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="product_details_pc">
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">国家高新技术企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">江苏省潜在独角兽企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">苏州培育独角兽</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">国家级专精特新"小巨人"小企业</div>
            </div>
          </div>
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">吴江区科技领军人才企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">科创数智化先进企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">江苏省民营科技企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">企业信用评价AAA级信用企业</div>
            </div>
          </div>
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">苏州市低温金属化浆料工程技术研究中心</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">......</div>
            </div>
          </div>
        </div>
        <div class="product_details_mobile">
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">国家高新技术企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">江苏省潜在独角兽企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">苏州培育独角兽</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">国家级专精特新"小巨人"小企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">吴江区科技领军人才企业</div>
            </div>
          </div>
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">科创数智化先进企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">江苏省民营科技企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">企业信用评价AAA级信用企业</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">苏州市低温金属化浆料工程技术研究中心</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">......</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section progress" ref="team" id="history">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">发展历程</div>
          <div class="tag"></div>
        </h2>
        <div class="step_pc">
          <el-carousel
            ref="stepCarousel"
            :interval="5000"
            arrow="always"
            height="110px"
            indicator-position="none"
            :autoplay="true"
            @change="progressChange"
          >
            <el-carousel-item v-for="(item, index) in progress" :key="index">
              <div class="custom">
                <div class="year">
                  {{ item.year }}
                </div>
                <div class="detail_item">
                  <div class="line" v-for="(desc, idx) in item.desc" :key="idx">
                    <div class="dot"></div>
                    <div class="txt">{{ desc }}</div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
         <div class="step_mobile">
          <el-carousel
            ref="stepCarousel"
            :interval="5000"
            arrow="always"
            height="190px"
            indicator-position="none"
            :autoplay="true"
            @change="progressChange"
          >
            <el-carousel-item v-for="(item, index) in progress" :key="index">
              <div class="custom">
                <div class="year">
                  {{ item.year }}
                </div>
                <div class="detail_item">
                  <div class="line" v-for="(desc, idx) in item.desc" :key="idx">
                    <div class="dot"></div>
                    <div class="txt">{{ desc }}</div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="steps_wrapper">
        <div class="steps">
          <div
            class="step"
            v-for="(item, index) in steps"
            :key="index"
            :class="{ active: index === activeStep }"
            @click="setActiveStep(index)"
          >
            <div class="dot"></div>
            <div class="year">{{ item.year }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <img class="mountain mountain_pc" src="../static/about/mountain.png" alt="" />
      <img class="mountain mountain_mobile" src="../static/about/mountain_mobile.png" alt="" />
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import { isInViewport, throttle } from "../utils/animation";

import NumberCounter from "../components/NumberCounter.vue";
import HorizontalScroll from "../components/HorizontalScroll.vue";
import HorizontalScrollIntervalPro from "../components/HorizontalScrollIntervalPro.vue";

import { AboutAPI } from "../api/api";
import { imgBaseUrl } from "../api/config";
export default {
  name: "About",
  components: {
    Header,
    Footer,
    NumberCounter,
    HorizontalScroll,
    HorizontalScrollIntervalPro,
  },
  computed: {
    // honorImages() {
    //   const images = [
    //     require("@/static/honor/honor_1.jpg"),
    //     require("@/static/honor/honor_2.jpg"),
    //     require("@/static/honor/honor_3.jpg"),
    //     require("@/static/honor/honor_4.jpg"),
    //     require("@/static/honor/honor_5.jpg"),
    //     require("@/static/honor/honor_6.jpg"),
    //     require("@/static/honor/honor_7.jpg"),
    //     require("@/static/honor/honor_8.jpg"),
    //     require("@/static/honor/honor_9.jpg"),
    //   ];
    //   return [...images]; // 使用展开运算符创建新数组
    // },
  },
  data() {
    return {
      aboutContent: '',
      cooperationImagePC: [],
      cooperationImageMobile: [],
      honorImages: [],

      honorPre: "",
      honorNext: "",

      activeStep: 0,
      steps: [
        // { year: 2019, desc: "开创起点" },
        // { year: 2021, desc: "破局起航" },
        // { year: 2022, desc: "技术筑基" },
        // { year: 2023, desc: "量产突破" },
        // { year: 2024, desc: "多元布局" },
        // { year: 2025, desc: "引领突破" },
      ],
      progress: [
        // {
        //   year: 2019,
        //   desc: [
        //     "公司成立于苏州市吴江经济技术开发区",
        //     "聚焦电子粉体与浆料研发",
        //   ],
        // },
        // {
        //   year: 2021,
        //   desc: ["低温银浆实现进口替代", "完成天使轮融资，迈出国产化关键一步"],
        // },
        // {
        //   year: 2022,
        //   desc: [
        //     "掌握低温高烧结活性银粉技术，实现银粉 - 银浆一体化量产",
        //     "自研银包铜粉进入中试阶段",
        //     "完成 A 轮融资，研发体系初具规模",
        //   ],
        // },
        // {
        //   year: 2023,
        //   desc: [
        //     "银包铜浆料（含银量 50%）及上游粉体实现一体化量产",
        //     "完成行业头部客户验证，批量出货",
        //     "完成 B 轮融资，市场拓展提速",
        //   ],
        // },
        // {
        //   year: 2024,
        //   desc: [
        //     "银包铜浆料含银量降至 30%，持续推动光伏降本",
        //     "启动高温银包镍浆料、超微焊锡膏及 200nm 以下银粉研发",
        //     "完成 C 轮融资，技术矩阵加速成型",
        //     "通过江苏省专精特新中小企业认定",
        //   ],
        // },
        // {
        //   year: 2025,
        //   desc: [
        //     "全球率先实现 10% 银含量银包铜浆料量产",
        //     "MLCC 陶瓷介质粉体进入中试",
        //     "超微焊料与焊锡膏实现一体化量产，性能比肩国际水平",
        //     "通过国家专精特新 “小巨人” 企业认定",
        //   ],
        // },
      ],
      introVisible: true,
    };
  },
  created() {
    AboutAPI.getAllAboutData().then((res) => { 
      console.log('关于我们数据', res);
      const { aboutContent, cooperationPartners, developmentHistories, qualificationHonors } = res;
      this.aboutContent = aboutContent.content;
      let arr = cooperationPartners || [];

      this.cooperationImageMobile = imgBaseUrl + cooperationPartners[1].imageUrl
      this.cooperationImagePC = imgBaseUrl + cooperationPartners[0].imageUrl

      this.honorImages = qualificationHonors.map((item) => `${imgBaseUrl}${item.imageUrl}`);

      let steps = []
      let progress = []
      developmentHistories.forEach(item => {
        steps.push({ year: item.year, desc: item.title })
        progress.push({
          year: item.year,
          desc: item.milestones ? (JSON.parse(item.milestones) || []).map(item => item.description) : [],
        })
      })
      this.steps = steps
      this.progress = progress
    });
  },
  mounted() {
    this.setupSectionObserver();
    this.getNeighbors(0);
  },

  methods: {
    setActiveStep(index) {
      this.$refs.stepCarousel.setActiveItem(index);
    },
    getNeighbors(index) {
      let arr = [...this.honorImages];
      const length = arr.length;
      if (length === 0) return { prev: null, current: null, next: null };

      const prevIndex = index === 0 ? length - 1 : index - 1;
      const nextIndex = index === length - 1 ? 0 : index + 1;

      this.honorPre = arr[prevIndex];
      this.honorNext = arr[nextIndex];
    },

    honorChange(index) {
      // console.log(999, index);
      this.getNeighbors(index);
    },
    progressChange(index) {
      // console.log(66666, index);
      this.activeStep = index;
    },

    // 监听内容进入可视区域  -- 数字开始滚到
    setupSectionObserver() {
      const options = {
        root: null,
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      };

      this.sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const target = entry.target;
          switch (target.dataset.section) {
            case "intro":
              this.introVisible = true;
              break;
            default:
              break;
          }
          // 触发后取消观察，避免重复计算
          this.sectionObserver.unobserve(target);
        });
      }, options);

      this.registerSection(this.$refs.introSection, "intro");
    },
    registerSection(sectionEl, name) {
      if (!sectionEl || !this.sectionObserver) return;
      sectionEl.dataset.section = name;
      this.sectionObserver.observe(sectionEl);
    },
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    // padding-bottom: 100px;
    padding-top: 100px;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/about/head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      h1 {
        margin-top: 275px;
        font-size: 48px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;
          text-decoration: none;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 40px !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
  }

  .intro {
    // padding-top: 70px;

    .intro_content {
      display: flex;
      align-items: stretch;
      gap: 96px;

      .left {
        .title {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 36px;

          .txt {
            white-space: nowrap;
            font-weight: 600;
            font-size: 40px;
            color: #363636;

            span {
              color: #0248ff;
            }
          }

          .tag {
            margin-top: 16px;
            width: 24px;
            height: 3px;
            background: #0248ff;
          }
        }

        .img_wrapper {
          padding-top: 56.3%;
          // background: pink;
          margin-bottom: 20px;
          background: url("../static/about/about1.png") center/cover no-repeat;
        }

        .img_wrapper:nth-last-of-type(1) {
          margin-bottom: 0;
          background: url("../static/about/about2.png") center/cover no-repeat;
        }
      }
    }

    .right {
      .desc {
        font-weight: 400;
        font-size: 14px;
        color: #888888;
        line-height: 26px;

        /deep/h3 {
          // margin: 28px 0 10px;
          font-weight: 600;
          font-size: 16px;
          color: #0248ff;
        }

        /deep/p:nth-last-of-type(1) {
          margin-top: 20px;
        }
      }

      .numbers {
        // margin-top: 56px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;

        .number-counter {
          min-width: 150px;
          font-weight: 500;
          font-size: 72px;
          color: #0248ff;
          margin-bottom: 10px;
        }

        p {
          white-space: nowrap;
          font-weight: 400;
          font-size: 16px;
          color: #808080;
        }
      }
    }
  }

  .target {
    .img-wrapper {
      padding-top: 35.1%;
      background: url("../static/about/target.png") center/cover no-repeat;
    }

    .target_extra {
      transform: translateY(-50%);
      margin: 0 auto;
      width: 1226px;
      display: flex;
      padding: 84px 0;
      background: #f9fafc;

      .target_item {
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 56px;

        .icon {
          margin-right: 34px;
          width: 52px;
          height: 52px;
          background: url("../static/about/target_icon1.png") center/cover
            no-repeat;
        }

        .detail {
          line-height: 1;

          .title {
            margin-bottom: 17px;
            font-size: 20px;
            color: #000000;
            font-weight: bold;
          }

          .desc {
            font-size: 16px;
            color: #808080;
          }
        }
      }

      .target_item:nth-last-of-type(1) {
        border-left: 1px solid #dadcdb;

        .icon {
          background: url("../static/about/target_icon2.png") center/cover
            no-repeat;
        }
      }
    }
  }

  .coopration {
    padding-top: 0 !important;

    .section-container {
      padding: 0 !important;

      .companys {
        width: 100%;
      }
      .companys_pc{
        display: block;
      }
      .companys_mobile{
        display: none;
      }
    }

    .title {
      margin-bottom: 27px;
      text-align: center;
      font-weight: 600;
      font-size: 40px;
      color: #363636;
    }

    .title_desc {
      margin-bottom: 60px;
      text-align: center;

      font-size: 16px;
      color: #808080;
    }
  }

  .honor {
    padding-top: 0 !important;
  }

  .progress,
  .honor {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 72px;

      .txt {
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }

      .tag {
        margin-top: 24px;
        width: 24px;
        height: 3px;
        background: #0248ff;
      }
    }

    .product_details_pc {
      display: flex;
    }

    .product_details_mobile {
      display: none;
    }

    .product_details_pc {
      margin-top: 72px;
      display: flex;
      gap: 63px;

      .detail_item {
        flex: 1;

        .line {
          display: flex;
          align-items: flex-start;

          .dot {
            margin-top: 10px;
            flex-shrink: 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: #888;
            margin-right: 8px;
          }

          .txt {
            font-size: 14px;
            color: #888888;
            line-height: 26px;

            span {
              font-weight: 600;
              color: #0248ff;
            }
          }
        }
      }
    }
  }

  .honor {
    .custom_carousel {
      display: flex;
      align-items: center;

      .left,
      .right {
        width: 294px;
        height: 196px;
        display: flex;
        align-items: center;
        justify-content: center;
        // 约束图片范围，防止溢出
        position: relative;
        overflow: hidden;

        img {
          height: 100%;
          width: auto;
          position: relative;
        }
      }

      .middle {
        flex: 1;
      }
    }

    .partner_logo {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        object-fit: contain;
      }
    }

    .pc_honor {
      display: block;
    }

    .mobile_hornor {
      display: none;
    }
  }

  .progress {
    font-size: 0;
    padding-bottom: 0 !important;

    .custom {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 42px;

      .year {
        line-height: 1;
        font-family: OutfitFont;
        font-size: 144px;
        color: #0248ff;
        font-weight: 600;
      }

      .detail_item {
        .line {
          display: flex;
          align-items: flex-start;

          .dot {
            margin-top: 10px;
            flex-shrink: 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: #888;
            margin-right: 8px;
          }

          .txt {
            font-size: 14px;
            color: #888888;
            line-height: 26px;

            span {
              font-weight: 600;
              color: #0248ff;
            }
          }
        }
      }
    }

    .step_pc{
      display: block;
    }
    .step_mobile{ 
      display: none;
    }

    .steps_wrapper {
      margin-top: 102px;
      border-top: 1px solid #dadcdb;

      .steps {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 1400px;
        margin: 0 auto;

        .step {
          cursor: pointer;
          position: relative;
          top: -4px;
          line-height: 1;
          font-size: 18px;
          color: #888888;
          text-align: center;

          .dot {
            margin-bottom: 18px;
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #dadcdb;
            border-radius: 50%;
          }

          .year {
            margin-bottom: 10px;
          }

          .desc {
            font-size: 16px;
          }
        }

        .active {
          color: #0248ff;

          .dot {
            background: #0248ff;
          }
        }
      }
    }

    .mountain {
      width: 100%;
    }
    .mountain_mobile{
      display: none;
    }
    .mountain_pc{
      display: block;
    }
  }

  /deep/.scroll-right-btn {
    right: 326px;
  }
  /deep/.scroll-left-btn {
    left: 326px;
  }
}
// mobile
@media (max-width: 750px) {
  .section {
    padding-top: 50px;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    background: url("../static/about/head_bg_mobile.png");
    background-size: 100% 100%;

    .hero-overlay {
      padding-top: 55px;

      h1 {
        line-height: 174px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
      }

      .tabs {
        display: none !important;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;
          text-decoration: none;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
  }

  .intro {
    padding-top: 20px;

    .intro_content {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 30px;

      .left {
        .title {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 18px;

          .txt {
            white-space: nowrap;
            font-weight: 600;
            font-size: 20px;
            color: #363636;

            span {
              color: #0248ff;
            }
          }

          .tag {
            margin-top: 16px;
            width: 12px;
            height: 2px;
            background: #0248ff;
          }
        }

        .img_wrapper {
          padding-top: 56.3%;
          // background: pink;
          margin-bottom: 10px;
          background: url("../static/about/about1.png") center/cover no-repeat;
        }

        .img_wrapper:nth-last-of-type(1) {
          margin-bottom: 0;
          background: url("../static/about/about2.png") center/cover no-repeat;
        }
      }
    }

    .right {
      .desc {
        font-weight: 400;
        font-size: 12px;
        color: #888888;
        line-height: 18px;

        /deep/h3 {
          margin: 13px 0 6px;
          font-weight: 600;
          font-size: 16px;
          color: #0248ff;
        }

        /deep/p:nth-last-of-type(1) {
          margin-top: 14px;
        }
      }

      .numbers {
        margin-top: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;

        .number-counter {
          min-width: 75px;
          font-weight: bold !important;
          font-size: 36px;
          color: #0248ff;
          margin-bottom: 10px;
        }

        p {
          white-space: nowrap;
          font-weight: 400;
          font-size: 12px;
          color: #808080;
        }
      }
    }
  }

  .target {
    padding-bottom: 50px;
    .img-wrapper {
      padding-top: 35.1%;
      background: url("../static/about/target.png") center/cover no-repeat;
    }

    .target_extra {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding: 24px 0;
      background: #f9fafc;

      .target_item {
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 10px;

        .icon {
          margin-right: 17px;
          width: 26px;
          height: 26px;
          background: url("../static/about/target_icon1.png");
          background-size: 100% 100%;
        }

        .detail {
          line-height: 1;

          .title {
            margin-bottom: 8px;
            font-size: 14px;
            color: #000000;
            font-weight: bold;
          }

          .desc {
            font-size: 12px;
            color: #808080;
          }
        }
      }

      .target_item:nth-last-of-type(1) {
        .icon {
          background: url("../static/about/target_icon2.png") center/cover
            no-repeat;
        }
      }
    }
  }

  .coopration {
    // padding-top: 0 !important;
    padding-bottom: 30px;
    background: #f3f3f3;

    .section-container {
      padding: 0 24px !important;

      .companys {
        width: 100%;
      }
      .companys_pc{
        display: none;
      }
      .companys_mobile{
        display: block;
      }
    }

    .title {
      margin-bottom: 27px;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      color: #363636;
    }

    .title_desc {
      margin-bottom: 30px;
      text-align: center;

      font-size: 12px;
      color: #808080;
    }
  }

  .progress,
  .honor {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 36px;

      .txt {
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }

      .tag {
        margin-top: 12px;
        width: 12px;
        height: 2px;
        background: #0248ff;
      }
    }

    .product_details_pc {
      display: none;
    }

    .product_details_mobile {
      margin-top: 72px;
      display: flex;
      gap: 30px;

      .detail_item {
        flex: 1;

        .line {
          display: flex;
          align-items: flex-start;

          .dot {
            margin-top: 10px;
            flex-shrink: 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: #888;
            margin-right: 8px;
          }

          .txt {
            font-size: 12px;
            color: #888888;
            line-height: 26px;

            span {
              font-weight: 600;
              color: #0248ff;
            }
          }
        }
      }
    }
  }

  .honor {
    .pc_honor {
      display: none;
    }

    .mobile_hornor {
      display: block;
      /deep/.el-carousel__arrow--left {
        left: 0;
        width: 24px;
        height: 24px;
        color: #0248FF;
        background: rgba(236, 241, 255, 1);
      }
      /deep/.el-carousel__arrow--right {
        right: 0;
        width: 24px;
        height: 24px;
        color: #0248FF;
        background: rgba(236, 241, 255, 1);
      }
      .custom {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        img {
          width: 274px;
          height: 185px;
        }
      }
    }

    .custom_carousel {
      display: flex;
      align-items: center;

      .left,
      .right {
        width: 294px;
        height: 196px;
        display: flex;
        align-items: center;
        justify-content: center;
        // 约束图片范围，防止溢出
        position: relative;
        overflow: hidden;

        img {
          height: 100%;
          width: auto;
          position: relative;
        }
      }

      .middle {
        flex: 1;
      }
    }

    .partner_logo {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        object-fit: contain;
      }
    }
  }

  .progress {
    font-size: 0;
    padding-bottom: 0 !important;

    .custom {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;

      .year {
        line-height: 1;
        font-family: OutfitFont;
        font-size: 72px;
        color: #0248ff;
        font-weight: 600;
      }

      .detail_item {
        .line {
          display: flex;
          align-items: flex-start;

          .dot {
            margin-top: 10px;
            flex-shrink: 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: #888;
            margin-right: 8px;
          }

          .txt {
            font-size: 12px;
            color: #888888;
            line-height: 26px;

            span {
              font-weight: 600;
              color: #0248ff;
            }
          }
        }
      }
    }

    /deep/.el-carousel__arrow--left {
        left: 0;
        width: 24px;
        height: 24px;
        color: #0248FF;
        background: rgba(236, 241, 255, 1);
      }
      /deep/.el-carousel__arrow--right {
        right: 0;
        width: 24px;
        height: 24px;
        color: #0248FF;
        background: rgba(236, 241, 255, 1);
      }

    .step_pc{
      display: none;
    }
    .step_mobile{ 
      display: block;
    }

    .steps_wrapper {
      margin-top: 32px;
      border-top: 1px solid #dadcdb;

      .steps {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;

        .step {
          cursor: pointer;
          position: relative;
          top: -2px;
          line-height: 1;
          font-size:16px;
          color: #888888;
          text-align: center;

          .dot {
            margin-bottom: 18px;
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #dadcdb;
            border-radius: 50%;
          }

          .year {
            margin-bottom: 5px;
            font-size: 13px;
          }

          .desc {
            font-size: 10px;
          }
        }

        .active {
          color: #0248ff;

          .dot {
            background: #0248ff;
          }
        }
      }
    }

    .mountain {
      width: 100%;
    }
    .mountain_mobile{
      display: block;
      margin-top: 50px;
    }
    .mountain_pc{
      display: none;
    }
  }

  /deep/.scroll-right-btn {
    right: 326px;
  }
  /deep/.scroll-left-btn {
    left: 326px;
  }
}
</style>
